var App = (function productPage(){
  // Assign relevant html elements to constants
  const productTitle  = document.querySelector('#productTitle');
  const variantTitle  = document.querySelector('#variantTitle');
  const image         = document.querySelector('#productImage');
  const qtyAvailable  = document.querySelector('#productAvailability');
  const option        = document.querySelector('#productOption');
  const price         = document.querySelector('#productPrice');
  const variantID     = document.querySelector('#variantID');
  const productID     = document.querySelector('#productID');
  const header        = document.querySelector('.c-header');
  var arrayOfVariants = document.getElementById('variantsGrid');

  var numberOfVariants = arrayOfVariants.children.length;

  var publicAPI = {
    init: init
  };

  return publicAPI;
  // -------------
  function init(){
    if(numberOfVariants < 1){
      updateViewerWithCurrentProduct();
    } else {
      updateViewerWithCurrentVariant(0);
      arrayOfVariants.children[0].classList.add("js-active");
      activateVariantGrid();
    }
  };
    
  function activateVariantGrid(){
    // Loop through variants to control the product in the product viewer
    for (let i = 0; i < numberOfVariants; i++){
    
      arrayOfVariants.children[i].addEventListener("click", function onClick(){
        updateViewerWithCurrentVariant(i);
          
        // Remove all active classes from variants
        for (let i = 0; i < numberOfVariants; i++){
          arrayOfVariants.children[i].classList.remove("js-active"); 
        }
          
        // Apply active class to this variant only
        this.classList.add("js-active");
        // Scroll up to product viewer
        zenscroll.to(header);
      });  
    }
  }

  function updateViewerWithCurrentProduct(){
    $(".quickAdd").show();

    if(product.variants[0].inventory_quantity < 1){
      $(".quickAdd").hide();
    }
    
    price.innerHTML = convertPriceToPounds(product.variants[0].price);
    variantID.setAttribute("value", product.variants[0].id);
    qtyAvailable.innerHTML = returnAvailability(product.variants[0].inventory_quantity);
    
  }

  function updateViewerWithCurrentVariant(x){
    $(".quickAdd").show();
    
    // identify the current variant
    let currentVariant = product.variants[x]; 

    if(currentVariant.inventory_quantity < 1){
      $(".quickAdd").hide();
    }
           
    // update the details in the product viewing area  
    productTitle.innerHTML = product.title;
    image.src = currentVariant.featured_image.src;
    price.innerHTML = convertPriceToPounds(currentVariant.price);
    variantID.setAttribute("value", currentVariant.id);
    
    qtyAvailable.innerHTML = returnAvailability(currentVariant.inventory_quantity);
    
    // If there are variants, display the variant title below the product title
    if (variantTitle != null){ 
      variantTitle.innerHTML = currentVariant.options[0];
    }
    
    // if the product has a custom taxonomy (eg. capacity in Litres) then update it
    if (option != null){ 
      option.innerHTML = currentVariant.options[1];
    }
  };

  function returnAvailability(qty){
    if (qty > 0){  
      if (qty > 20){
        return "20+ available";
      }else{
        return qty + " available";
      }
    }else{
      return "Out of stock";
    } 
  };

  function convertPriceToPounds(price){
    return "£"+((price)/100).toFixed(2);
  };

})();

App.init();

// // Assign relevant html elements to constants
// const htmlTitle         = document.querySelector('#productTitle');
// const htmlVariant       = document.querySelector('#productVariantTitle');
// const htmlImage         = document.querySelector('#productImage')
// const htmlDescription   = document.querySelector('#productDescription');
// const htmlAvailability  = document.querySelector('#productAvailability');
// const htmlOption        = document.querySelector('#productOption');
// const htmlPrice         = document.querySelector('#productPrice');
// const htmlID            = document.querySelector('#productID');
// const viewer            = document.querySelector('#productViewer');

// // Update price in the instance where there are no variants
//  htmlPrice.innerHTML = "£"+((product.variants[0].price)/100).toFixed(2);
//  htmlID.setAttribute("value", product.variants[0].id);

// // Code to change the product shown in the product viewer
// function focusOnItem(x){

//   // identify the active variant
//   var activeVariant = product.variants[x]; 
         
//   // update the product details in the product viewing area  
//   htmlTitle.innerHTML = product.title;
//   if (htmlVariant != null){ 
//     htmlVariant.innerHTML = activeVariant.options[0];
//   }
//   htmlPrice.innerHTML = "£"+((activeVariant.price)/100).toFixed(2);
//   htmlImage.src = activeVariant.featured_image.src;
//   htmlID.setAttribute("value", activeVariant.id);
//   // if the product has a custom taxonomy (eg. capacity in Litres) then update it
//   if (htmlOption != null){ 
//     htmlOption.innerHTML = activeVariant.options[1];
//   }
//   htmlAvailability.innerHTML = logic();

//   function logic(){

//     if (activeVariant.inventory_quantity > 0){  

//       if (activeVariant.inventory_quantity > 20){
//         return "20+ available";
//       }else{
//         return activeVariant.inventory_quantity + " available";
//       }

//     }else{

//       return "Out of stock";
//     } 
//   }; // END logic();
// }; // END focusOnItem



// // Gather all variants on the page
// var g = document.getElementById('variantsGrid');
// var children = g.children;

// // Loop through variants to control the product in the product viewer
// for (var i = 0, len = g.children.length; i < len; i++){
    
//   (function(index){
//     // Count homw many products there are
//     if (product.variants.length > 0){
//       // display the first in the product viewer on page load
//       focusOnItem(0);
//       // And add the active class to the item on the grid
//       g.children[0].classList.add("js-active");
//     };

//     // Whenever one is clicked, display it in the product viewer
//     g.children[i].onclick = function(){
//       // Update focused item using index number
//       focusOnItem(index);
//       // Strip off all active classes from variants
//       for (var i = 0, len = g.children.length; i < len; i++){
//         g.children[i].classList.remove("js-active"); 
//       }
//       // Apply active class to this element
//       this.classList.add("js-active");

//       // Scroll up to product viewer
//       zenscroll.to(viewer);
//     }    
//   })(i);
// }

// // Retrieve product & variant info as json object
// // const product = {{ product | json }}
// console.log(product);

// // Assign relevant html elements to constants
// const htmlTitle         = document.querySelector('#productTitle');
// const htmlVariant       = document.querySelector('#productVariantTitle');
// const htmlImage         = document.querySelector('#productImage')
// const htmlDescription   = document.querySelector('#productDescription');
// const htmlAvailability  = document.querySelector('#productAvailability');
// const htmlOption        = document.querySelector('#productOption');
// const htmlPrice         = document.querySelector('#productPrice');
// const htmlID            = document.querySelector('#productID');
// const viewer            = document.querySelector('.c-header');

// // Update price in the instance where there are no variants
//  htmlPrice.innerHTML = "£"+((product.variants[0].price)/100).toFixed(2);
//  htmlID.setAttribute("value", product.variants[0].id);

// // Code to change the product shown in the product viewer
// function focusOnItem(x){

//   // identify the active variant
//   var activeVariant = product.variants[x]; 
         
//   // update the product details in the product viewing area  
//   htmlTitle.innerHTML = product.title;
//   if (htmlVariant != null){ 
//     htmlVariant.innerHTML = activeVariant.options[0];
//   }
//   htmlPrice.innerHTML = "£"+((activeVariant.price)/100).toFixed(2);
//   htmlImage.src = activeVariant.featured_image.src;
//   htmlID.setAttribute("value", activeVariant.id);
//   // if the product has a custom taxonomy (eg. capacity in Litres) then update it
//   if (htmlOption != null){ 
//     htmlOption.innerHTML = activeVariant.options[1];
//   }
//   htmlAvailability.innerHTML = logic();

//   function logic(){

//     if (activeVariant.inventory_quantity > 0){  

//       if (activeVariant.inventory_quantity > 20){
//         return "20+ available";
//       }else{
//         return activeVariant.inventory_quantity + " available";
//       }

//     }else{

//       return "Out of stock";
//     } 
//   }; // END logic();
// }; // END focusOnItem

// // Gather all variants on the page
// var g = document.getElementById('variantsGrid');
// var children = g.children;

// // Loop through variants to control the product in the product viewer
// for (var i = 0, len = g.children.length; i < len; i++){
    
//   (function(index){
//     // If there are variants
//     if (product.variants.length > 1){
//       // display the first in the product viewer on page load
//       focusOnItem(0);
//       // And add the active class to the item on the grid
//       g.children[0].classList.add("js-active");
//     };

//     // Whenever one is clicked, display it in the product viewer
//     g.children[i].onclick = function(){
//       // Update focused item using index number
//       focusOnItem(index);
//       // Strip off all active classes from variants
//       for (var i = 0, len = g.children.length; i < len; i++){
//         g.children[i].classList.remove("js-active"); 
//       }
//       // Apply active class to this element
//       this.classList.add("js-active");

//       // Scroll up to product viewer
//       zenscroll.to(viewer);
//     }    
//   })(i);
// }